export default __webpack_public_path__ + "static/media/1964.cd206d1e.jpg";